import styled, { css } from 'styled-components';
import { em, rem } from 'styles';
import { PALETTE } from '../../fields.constants';

export const Section = styled.section`
  padding: ${em(12)} 0 ${em(16)};
  border-top: ${em(1)} solid ${PALETTE.line};
`;

export const Head = styled.div`
  display: flex;
  align-items: baseline;
  gap: ${em(10)};
  margin-bottom: ${em(10)};

  h3 {
    margin: 0;
    font-size: ${rem(15)};
    color: ${PALETTE.ink};
  }
`;

export const Hint = styled.span`
  flex: 1;
  font-size: ${rem(12.5)};
  color: ${PALETTE.muted};
`;

export const Track = styled.div`
  display: flex;
  gap: ${em(10)};
  overflow-x: auto;
  padding-bottom: ${em(3)};
`;

export const Card = styled.button`
  flex: 0 0 ${em(228)};
  display: flex;
  flex-direction: column;
  padding: ${em(11)} ${em(12)};
  text-align: left;
  background: #fff;
  border: ${em(1)} solid ${({ $open }) => ($open ? PALETTE.brandBorder : PALETTE.line)};
  border-radius: ${em(6)};
  cursor: pointer;

  &:hover {
    border-color: ${PALETTE.faint};
  }

  &[aria-pressed='true'] {
    background: ${PALETTE.brandTint};
    border-color: ${PALETTE.brand};
    box-shadow: inset 0 0 0 ${em(1)} ${PALETTE.brand};
  }
`;

export const Title = styled.span`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: ${em(8)};
  font-size: ${rem(14.5)};
  font-weight: 700;
  color: ${PALETTE.ink};
`;

export const Tag = styled.span`
  padding: ${em(1)} ${em(7)};
  font-size: ${rem(11)};
  font-weight: 400;
  color: ${({ $open }) => ($open ? PALETTE.brandDark : PALETTE.muted)};
  background: ${({ $open }) => ($open ? PALETTE.brandTint : 'transparent')};
  border: ${em(1)} solid ${({ $open }) => ($open ? PALETTE.brandBorder : PALETTE.line)};
  border-radius: 999px;
`;

export const Detail = styled.span`
  font-size: ${rem(12.5)};
  color: ${PALETTE.muted};
`;

export const Percent = styled.span`
  ${({ $muted }) => css`
    margin-top: ${em(7)};
    font-size: ${rem(22)};
    font-weight: 500;
    font-variant-numeric: tabular-nums;
    color: ${$muted ? PALETTE.faint : PALETTE.ink};
  `}
`;

export const Sub = styled.span`
  font-size: ${rem(12.5)};
  color: ${PALETTE.muted};

  b {
    font-weight: 500;
    color: ${PALETTE.ink};
  }
`;

export const Exported = styled.span`
  display: block;
  margin-top: 7px;
  padding-top: 6px;
  font-size: 11.5px;
  color: ${({ $nil }) => ($nil ? PALETTE.faint : PALETTE.muted)};
  border-top: 1px solid ${PALETTE.line};
  overflow-wrap: anywhere;

  b {
    font-weight: 500;
    color: ${PALETTE.ink};
  }
`;
